<template>
  <crudTable :config="config"></crudTable>
</template>
<script>
//importare e registrare qui tutti i componenti child della tabella.(non in crudTableHeader/crudTableRow)
//NB : le operazioni crud a livello di database vanno collocate  direttamente nel componente child
import { ref } from "@/components/puntatori";
import { EventBus } from "../main.js";
import Vue from "vue";
import crudTable from "@/components/crudTable";
Vue.component("crudTable", crudTable);
import crudTableMagazzinoImmagine from "@/components/crudTableMagazzinoImmagine";
Vue.component("crudTableMagazzinoImmagine", crudTableMagazzinoImmagine);
import crudTableMagazzinoDescrizione from "@/components/crudTableMagazzinoDescrizione";
Vue.component("crudTableMagazzinoDescrizione", crudTableMagazzinoDescrizione);
import crudTableMagazzinoStato from "@/components/crudTableMagazzinoStato";
Vue.component("crudTableMagazzinoStato", crudTableMagazzinoStato);
import crudTableMagazzinoCosto from "@/components/crudTableMagazzinoCosto";
Vue.component("crudTableMagazzinoCosto", crudTableMagazzinoCosto);

export default {
  name: "crudTableMagazzino",
  directives: {},

  data() {
    return {
      config: {
        tableRowsData: [],
        tableType: "table",
        //la variabile tableConfig deve essere SEMPRE dichiarata come 'prop' nei child del componente crudTable***
        source: "ricambi",
        tableColumns: [
          //{ title: "Titolo", style: "width:100px" },
          {
            string: "Immagine",
            style: "color:red; width:9vw; text-align:center;"
          },
          { string: "Descrizione", style: "flex:1;" },
          { string: "Tipologia", style: "width:10vw; text-align:center;" },
          { string: "Quantità", style: "width:10vw; text-align:center;" },
          { string: "Stato", style: "width:10vw; text-align:center;" },
          { string: "Costo", style: "width:8vw; text-align:center;" },
          { string: "Data", style: "width:8vw; text-align:center;" },
          { string: "Azioni", style: "width:8vw; text-align:center;" }
        ],
        tableRowsConfig: [
          {
            componentName: "crudTableMagazzinoImmagine",
            style:
              "width:9vw; display:flex; align-items: center; justify-content: center;"
          },
          { componentName: "crudTableMagazzinoDescrizione", style: "flex:1;" },
          { html: "Ricambi", style: "width:10vw; text-align:center; " },
          {
            componentName: "crudTableQuantityWidget",
            style: "width:10vw; text-align:center;"
          }, //il nome del componente registrato
          {
            componentName: "crudTableMagazzinoStato",
            style: "width:10vw; text-align:center;"
          },
          {
            componentName: "crudTableMagazzinoCosto",
            style: "width:8vw; text-align:center;"
          },
          {
            string: "data",
            style: "width:8vw; text-align:center;"
          },
          {
            componentName: "crudTableActionButton",
            style: "width:8vw; text-align:center;"
          }
          //il nome del componente registrato
        ],
        gridItemConfig: [
          //{ html: "<h1>prova html</h1>" }, // codice html
          //{ string: "titolo" },  //nome della key del nodo firebase
          //{ componentName: "crudTableActionButton" } //il nome del componente registrato
          //quando le cose si fanno più complicate di una semplice string o img o tag html fare componente
          { html: "<h1>CIAO</h1>", style: "color:red" },
          // { string: "regole" },
          { string: "Value,Category,Id", style: "width:100px" },
          { string: "Marca", children: [{ string: "Modello" }] },
          { string: "Scadenza,Costo,Prezzo,Id" },
          { string: "Quantità" },
          { string: "Azioni" },
          { value: "costo" },
          { componentName: "crudTableQuantityWidget" }, //il nome del componente registrato
          { componentName: "crudTableActionButton" } //il nome del componente registrato
        ]
      }
    };
  },
  computed: {},
  methods: {},
  mounted() {},
  watch: {
    $route() {}
  }
};
</script>

<style scoped>
.viewSwitch {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
